import type { HolidayContact } from '@/src/types/holidays'
import { isCleartrip } from '@/src/utils/generalUtils/isCleartrip'

const FLYIN_HOLIDAYS_CONTACT: HolidayContact = {
    phoneLabel: '600 544 405',
    email: 'holidays@flyin.com'
}

/** Already reads "powered by musafir.com"; 460×54. */
export const HOLIDAYS_POWERED_BY_LOGO = 'https://ui.cltp.co/images/Musafir.png'

export const HOLIDAY_PACKAGE_SORT = {
    PRICE_LOW_TO_HIGH: 'price_asc',
    PRICE_HIGH_TO_LOW: 'price_desc',
    NAME: 'name'
} as const

export type HolidayPackageSort = (typeof HOLIDAY_PACKAGE_SORT)[keyof typeof HOLIDAY_PACKAGE_SORT]

export const HOLIDAY_REGION = {
    EUROPE: 'europe',
    ASIA: 'asia',
    CENTRAL_ASIA: 'central_asia_caucasus',
    MIDDLE_EAST_AFRICA: 'middle_east_africa',
    OTHER: 'other'
} as const

export type HolidayRegion = (typeof HOLIDAY_REGION)[keyof typeof HOLIDAY_REGION]

// The API carries no region, so it is derived from the destination name and slug. First match wins;
// a destination missing here falls into OTHER rather than vanishing from the page.
export const HOLIDAY_REGION_KEYWORDS: Array<{ region: HolidayRegion; keywords: string[] }> = [
    {
        region: HOLIDAY_REGION.CENTRAL_ASIA,
        keywords: ['georgia', 'tbilisi', 'azerbaijan', 'baku', 'armenia', 'yerevan', 'uzbekistan', 'tashkent',
            'samarkand', 'almaty', 'kazakhstan', 'kyrgyzstan', 'bishkek']
    },
    {
        region: HOLIDAY_REGION.MIDDLE_EAST_AFRICA,
        keywords: ['egypt', 'cairo', 'salalah', 'oman', 'south africa', 'kenya', 'tanzania', 'zanzibar', 'morocco',
            'jordan', 'saudi', 'qatar', 'mauritius', 'seychelles']
    },
    {
        region: HOLIDAY_REGION.EUROPE,
        keywords: ['europe', 'finland', 'iceland', 'paris', 'france', 'amsterdam', 'netherlands', 'switzerland',
            'swiss', 'uk', 'united kingdom', 'london', 'scotland', 'russia', 'turkey', 'istanbul', 'italy', 'spain',
            'greece', 'austria', 'germany', 'prague', 'norway']
    },
    {
        region: HOLIDAY_REGION.ASIA,
        keywords: ['japan', 'china', 'vietnam', 'singapore', 'kuala lumpur', 'malaysia', 'bali', 'indonesia',
            'thailand', 'phuket', 'bangkok', 'pattaya', 'sri lanka', 'maldives', 'nepal', 'bhutan', 'korea',
            'philippines', 'india']
    }
]

/** Display order of the region filter and of grouped results. */
export const HOLIDAY_REGION_ORDER: HolidayRegion[] = [
    HOLIDAY_REGION.EUROPE,
    HOLIDAY_REGION.ASIA,
    HOLIDAY_REGION.CENTRAL_ASIA,
    HOLIDAY_REGION.MIDDLE_EAST_AFRICA,
    HOLIDAY_REGION.OTHER
]
const CLEARTRIP_HOLIDAYS_CONTACT: HolidayContact = {
    phoneLabel: '+971 4 875 4545',
    email: 'holidays@cleartrip.ae'
}

// Same for every holiday page of a brand; the build variant picks which.
export const HOLIDAYS_CONTACT: HolidayContact = isCleartrip() ? CLEARTRIP_HOLIDAYS_CONTACT : FLYIN_HOLIDAYS_CONTACT
